import React, { memo } from 'react';
import { Section } from '../ui/Section';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María L.',
    location: 'Buenos Aires',
    text: 'Pasé de cocinar todos los días a hacerlo solo los domingos. Mi freezer está lleno y mi estrés desapareció.',
    rating: 5
  }, {
    name: 'Carolina P.',
    location: 'Córdoba',
    text: 'El kit de ahorro inteligente es increíble. Comemos rico toda la semana gastando mucho menos que antes.',
    rating: 5
  }, {
    name: 'Luciana M.',
    location: 'Rosario',
    text: 'Con 3 chicos, esto me salvó la vida. Ahora tengo comida casera lista en 10 minutos.',
    rating: 5
  }];
  return <Section className="bg-brand-slate-50" data-id="element-214">
      <div className="text-center mb-6 md:mb-10" data-id="element-215">
        <span className="text-brand-caramel font-semibold text-xs md:text-sm uppercase tracking-wider" data-id="element-216">
          Testimonios
        </span>
        <h2 className="text-2xl md:text-4xl font-bold text-brand-slate-900 mt-2 mb-3 md:mb-4" data-id="element-217">
          Lo que dicen nuestras usuarias
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-218">
        {testimonials.map((t, i) => <div key={i} className="bg-white p-5 md:p-6 rounded-xl md:rounded-2xl border border-brand-slate-200" data-id="element-219">
            <div className="flex gap-0.5 mb-3 md:mb-4" data-id="element-220">
              {[...Array(t.rating)].map((_, j) => <Star key={j} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-221" />)}
            </div>
            <p className="text-brand-slate-700 mb-4 leading-relaxed text-sm md:text-base" data-id="element-222">
              "{t.text}"
            </p>
            <div className="pt-3 md:pt-4 border-t border-brand-slate-100" data-id="element-223">
              <p className="font-semibold text-brand-slate-900 text-sm md:text-base" data-id="element-224">
                {t.name}
              </p>
              <p className="text-xs md:text-sm text-brand-slate-500" data-id="element-225">
                {t.location}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}